export default __webpack_public_path__ + "static/media/loss-analysis-step-6.357260a1.gif";